import styled from 'styled-components';

export const ModalPTORequestItemContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  background: ${({ theme }) => theme.colors['neutral-10']};
  overflow: hidden;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;
